// extracted by mini-css-extract-plugin
export var paginationContainer = "_4p-0";